<template>
    <div class="container-fluid">
        <br>
        <router-link to="/planos" class="btn-default btn">
            <i class="fa fa-times"></i>
            {{$t('words.cancel') }}
        </router-link>
        <button type="button" :disabled="loading" @click="saveData" class="btn btn-lg btn-success float-right">
            <i class="fa fa-check"></i>
            {{$t('words.save')}}
            <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
        </button>
        <br>
        <br>
        <div class="card card-outline card-outline-tabs" :class="appLayout.card">
            <div class="card-header p-0 border-bottom-0">
                <div class="nav-tabs-custom" role="tabpanel">
                    <!-- Nav tabs -->
                    <ul class="nav nav-tabs" role="tablist">

                        <li role="presentation" class="nav-item">
                            <a class="nav-link active" href="#tabFormulario" aria-controls="tabFormulario" role="tab"
                                data-toggle="tab">
                                <i class="fa fa-tag"></i>
                                Dados dos Planos
                            </a>
                        </li>
                        <li role="presentation" class="nav-item">
                            <a class="nav-link" href="#tabModulos" aria-controls="tabModulos" role="tab"
                                data-toggle="tab">
                                <i class="fa fa-table"></i>
                                Módulos
                            </a>
                        </li>
                        <li role="presentation" class="nav-item">
                            <a href="#tabPublico" class="nav-link" aria-controls="tabPublico" role="tab"
                                data-toggle="tab">
                                <i class="fa fa-globe"></i>
                                Descrição Publica
                            </a>
                        </li>
                    </ul>
                </div>
                <div class="card-body">
                    <div class="tab-content">
                        <div class="tab-pane active" id="tabFormulario">
                            <span v-html="$t('validation.field_required')"></span>
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-group" :class="{'is-invalid': errors.has('Padrao')}">
                                        <p-radio value="D" name="Tipo" :color="appLayout.check" v-model="plano.ck_tipo"
                                            type="radio">
                                            Trial
                                        </p-radio>
                                        <p-radio value="P" name="Tipo" :color="appLayout.check" v-model="plano.ck_tipo"
                                            type="radio">
                                            Padrão
                                        </p-radio>
                                        <p-radio value="N" name="Tipo" :color="appLayout.check" v-model="plano.ck_tipo"
                                            type="radio">
                                            Negociável
                                        </p-radio>

                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <required /> <label>{{$t('attributes.name')}}</label>
                                        <input class="form-control" :class="{'is-invalid': errors.has('Nome')}"
                                            name="Nome" v-validate="{required: true, max:60}"
                                            :placeholder="$t('words.type_name')" v-model="plano.nome">
                                        <div class="invalid-feedback help-block error">{{errors.first('Nome')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <required /> <label>Valor Base</label>
                                        <money class="form-control" :class="{'is-invalid': errors.has('Valor')}"
                                            name="Valor" v-validate="{required: true,}" placeholder="Valor do plano"
                                            v-model="plano.valor"> </money>
                                        <div class="invalid-feedback help-block error">{{errors.first('Valor')}}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-3">
                                    <div class="form-group">
                                        <label>Ativo</label><br />
                                        <p-check class="p-switch p-fill" :class="{'is-invalid': errors.has('Ativo')}"
                                            :color="appLayout.switch" v-model="plano.ativo" type="checkbox">
                                            &nbsp;
                                        </p-check>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="tab-pane" id="tabModulos">
                            <tab-modulos :plano="plano"></tab-modulos>
                        </div>
                        <div class="tab-pane" id="tabPublico">
                            <table class="table table-sm table-hover  table-condensed">
                                <thead>
                                    <tr>
                                        <th scope="col" class="text-center"><strong>Recurso</strong></th>
                                        <th>
                                            <strong>Plano: {{plano.nome}}</strong>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody id="body" v-if="plano.publico">
                                    <!-- <template v-for="(item, r) in Object.entries(plano.publico)">
                                        <tr :key="`rowM${r}`">
                                            <th v-if="item[1] != null" class="recursos" :key="`thM${r}`">
                                                {{item[0]}}</th>
                                            <th v-if="item[1] == null" scope="row" class="tabletitle" :key="`thM${r}`"
                                                colspan="2">
                                                <strong>{{item[0]}}</strong></th>
                                            <td v-if="item[1] != null" :key="`colM${r}`">
                                                <select class="form-control" v-model="plano.publico[item[0]]">
                                                    <option :value="true">Sim</option>
                                                    <option :value="false">Não</option>
                                                    <option :value="'Consultar'">Consultar</option>
                                                    <option :value="'Ilimitado'">Ilimitado</option>
                                                    <option :value="'Manual'">Manual</option>
                                                    <option :value="'Automático'">Automático</option>
                                                    <option v-show="['Usuários', 'Limite Upload'].includes(item[0])"
                                                        :value="1">1</option>
                                                    <option v-show="['Usuários', 'Limite Upload'].includes(item[0])"
                                                        :value="2">2</option>
                                                    <option v-show="['Usuários', 'Limite Upload'].includes(item[0])"
                                                        :value="3">3</option>
                                                    <option v-show="['Usuários', 'Limite Upload'].includes(item[0])"
                                                        :value="4">4</option>
                                                    <option v-show="['Usuários', 'Limite Upload'].includes(item[0])"
                                                        :value="5">5</option>
                                                    <option
                                                        v-show="['Office', 'Mobile / Desk (Orçamentos)', 'Mobile / Desk com emissão SAT/NFC-e', 'Office com emissão de NF-e e MDF-e'].includes(item[0])"
                                                        :value="6">6</option>
                                                    <option
                                                        v-show="['Office', 'Mobile / Desk (Orçamentos)', 'Mobile / Desk com emissão SAT/NFC-e', 'Office com emissão de NF-e e MDF-e'].includes(item[0])"
                                                        :value="7">7</option>
                                                    <option
                                                        v-show="['Office', 'Mobile / Desk (Orçamentos)', 'Mobile / Desk com emissão SAT/NFC-e', 'Office com emissão de NF-e e MDF-e'].includes(item[0])"
                                                        :value="8">8</option>
                                                    <option
                                                        v-show="['Office', 'Mobile / Desk (Orçamentos)', 'Mobile / Desk com emissão SAT/NFC-e', 'Office com emissão de NF-e e MDF-e'].includes(item[0])"
                                                        :value="9">9</option>
                                                    <option
                                                        v-show="['Office', 'Mobile / Desk (Orçamentos)', 'Mobile / Desk com emissão SAT/NFC-e', 'Office com emissão de NF-e e MDF-e'].includes(item[0])"
                                                        :value="10">10</option>
                                                </select>
                                            </td>
                                        </tr>
                                    </template> -->
                                    <template v-for="(recurso, r) in recursos">
                                        <tr :key="`rowM${r}`">
                                            <th v-if="recurso.type=='row'" scope="row" class="tabletitle"
                                                :key="`thM${r}`" colspan="2">
                                                <strong>{{ recurso.item }}</strong>
                                            </th>
                                            <th v-if="recurso.type!='row'" class="recursos" :key="`thM${r}`">
                                                {{ recurso.item }}
                                            </th>
                                            <td v-if="recurso.type=='opt'" :key="`colM${r}`">
                                                <select class="form-control" v-model="plano.publico[recurso.item]">
                                                    <option :value="true">Sim</option>
                                                    <option :value="false">Não</option>
                                                    <option :value="'Consultar'">Consultar</option>
                                                    <option :value="'Ilimitado'">Ilimitado</option>
                                                    <option :value="'Manual'">Manual</option>
                                                    <option :value="'Automático'">Automático</option>
                                                </select>
                                            </td>
                                            <td v-else-if="recurso.type=='number'" :key="`colM${r}`">
                                                <input v-model="plano.publico[recurso.item]"
                                                    @change="plano.publico[recurso.item] = parseInt(plano.publico[recurso.item])"
                                                    type="number" class="form-control" min="1">
                                            </td>
                                            <td v-else-if="recurso.type=='money'" :key="`colM${r}`">
                                                <money v-model="plano.publico[recurso.item]"
                                                    @change="plano.publico[recurso.item] = parseInt(plano.publico[recurso.item])"
                                                    class="form-control" />
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import tabModulos from './components/tab-modulos.vue';
    export default {
        components: {
            tabModulos
        },
        data() {
            return {
                plano: {
                    nome: null,
                    valor: 0,
                    ativo: false,
                    modulos: [],
                    ck_tipo: 'D',
                    publico: null
                },
                recursos: [{
                        item: 'DocX Assinador Digital',
                        type: 'row'
                    },
                    {
                        item: 'Upload de PDF',
                        type: 'opt'
                    },
                    {
                        item: 'Assinatura',
                        type: 'opt'
                    },
                    {
                        item: 'Assinatura com certificado digital',
                        type: 'opt'
                    },
                    {
                        item: 'Gerenciamento de níveis',
                        type: 'opt'
                    },
                    {
                        item: 'Usuários',
                        type: 'number'
                    },
                    {
                        item: 'Validação por SMS',
                        type: 'money'
                    },
                    {
                        item: 'Signatários ilimitados',
                        type: 'opt'
                    },
                    {
                        item: 'Workflow dos Signatários',
                        type: 'opt'
                    },
                    {
                        item: 'Timeline, lembretes e status das assinaturas',
                        type: 'opt'
                    },
                    {
                        item: 'Suporte',
                        type: 'row'
                    },
                    {
                        item: 'Atendimentos horário comercial (Telefone e Remoto)',
                        type: 'opt'
                    },
                    {
                        item: 'Atendimento Presencial (horário comercial)',
                        type: 'opt'
                    },
                    {
                        item: 'Atendimento Presencial (Fora do horário comercial)',
                        type: 'opt'
                    },
                ],
                loading: false,
            };
        },
        watch: {
            $route(data) {
                this.$destroy();
            }
        },
        async beforeMount() {
            await this.$store.dispatch('getAllPlanoModulo');
            if (!this.plano.publico) this.plano.publico = this.publicData();
            if (this.$route.name === 'planoEdit') {
                await this.$store.dispatch('getPlanoById', this.$route.params.id).then(response => {
                    this.plano = response;
                    if (!this.plano.publico) this.plano.publico = this.publicData();
                    if (!this.plano.publico['Validação por SMS'])
                        this.plano.publico['Validação por SMS'] = 0.25;
                    if (!this.plano.publico['Signatários ilimitados'])
                        this.plano.publico["Signatários ilimitados"] = true;
                    if (!this.plano.publico['Workflow dos Signatários'])
                        this.plano.publico["Workflow dos Signatários"] = true;
                    if (!this.plano.publico['Timeline, lembretes e status das assinaturas'])
                        this.plano.publico["Timeline, lembretes e status das assinaturas"] = true;
                });
            }
        },
        mounted() {},
        methods: {
            saveData() {
                this.loading = true;
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.$route.name === 'planoEdit' ?
                            this.updateData('updatePlano', this.plano, '/planos') :
                            this.storeData('storePlano', this.plano);
                    } else this.loading = false;
                });
            },
            updateData() {
                this.$store.dispatch('updatePlano', this.plano).then(response => {
                    this.loading = false;
                    if (response.status == 'success') {
                        toastr({
                            title: response.message,
                            icon: response.status
                        });
                        this.$router.push('/planos');
                    }
                });
            },
            storeData() {
                this.$store.dispatch('storePlano', this.plano).then(response => {
                    this.loading = false;
                    if (response.status == 'success') {
                        toastr({
                            title: response.message,
                            icon: response.status
                        });
                        this.resetForm();
                        this.plano.publico = this.publicData();
                    }
                });
            },
            publicData() {
                return {
                    "DocX Assinador Digital": null,
                    "Upload de PDF": true,
                    "Assinatura": true,
                    "Assinatura com certificado digital": true,
                    "Visualização Histórico": true,
                    "Gerenciamento de níveis": true,
                    "Usuários": 1,
                    "Validação por SMS": 0.25,
                    "Signatários ilimitados": true,
                    "Workflow dos Signatários": true,
                    "Timeline, lembretes e status das assinaturas": true,
                    "Suporte": null,
                    "Atendimentos horário comercial (Telefone e Remoto)": true,
                    "Atendimento Presencial (horário comercial)": "Consultar",
                    "Atendimento Presencial (Fora do horário comercial)": "Consultar"
                }
            },
        },

    };
</script>
<style scoped>
    table {
        line-height: 1.5;
        font-size: 18px;
    }

    td,
    th {
        border-top: 1px solid #dee2e6 !important;
        border-bottom: 1px solid #dee2e6 !important;
        border-left: 0;
        border-right: 0;
        font-weight: 300;
        padding: 0;
        line-height: 1.5 !important;
    }

    .table thead th {
        padding: 0.5rem 0 !important;
        width: 10vw;
    }

    td[class*="p-"],
    .plan {
        text-align: center !important;
        color: white;
    }

    .plan {
        border-radius: 5px 5px 0 0;
    }

    tbody tr:hover {
        color: #212529;
        background-color: rgba(0, 0, 0, 0.075);
    }

    .tabletitle {
        background-color: lightgray;
    }

    .pp-0 {
        background-color: #6a89cc;
    }

    tr:hover .pp-0 {
        background-color: #6a89ccaa;
    }

    .pp-1 {
        background-color: #1e3799;
    }

    tr:hover .pp-1 {
        background-color: #1e3799aa;
    }

    .pp-2 {
        background-color: #001464;
    }

    tr:hover .pp-2 {
        background-color: #001464aa;
    }

    .pp-3 {
        background-color: #01104d;
    }

    tr:hover .pp-3 {
        background-color: #091546aa;
    }

    .pp-4 {
        background-color: #0e1638;
    }

    tr:hover .pp-4 {
        background-color: #272c42aa;
    }
</style>